"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var Pages_1 = require("./Pages");
var NotFound_1 = require("../../../NotFound");
var SiteLogo = require("Assets/Images/site_logo.png");
var CompanyLogo = require("Assets/Images/company_logo.png");
var Util_1 = require("../../../Services/Util");
var Registration = /** @class */ (function (_super) {
    __extends(Registration, _super);
    function Registration(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            resources: {}
        };
        Util_1.GetResources(function (resources) { _this.setState({ resources: resources }); });
        return _this;
    }
    Registration.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_1.Route, { exact: true, path: '/Registration/Organisation', render: function (props) { return React.createElement(Pages_1.Organisation, { resources: _this.state.resources, siteLogo: SiteLogo, companyLogo: CompanyLogo }); } }),
            React.createElement(react_router_1.Route, { render: function () { return React.createElement(NotFound_1.default, null); } })));
    };
    return Registration;
}(React.Component));
exports.Registration = Registration;
//# sourceMappingURL=Registration.js.map